var map = {
	"./doc.png": "2570",
	"./img.png": "cd14",
	"./mp3.png": "c300",
	"./pdf.png": "3263",
	"./ppt.png": "9f03",
	"./system_file.png": "d2be",
	"./system_img.png": "b0a0",
	"./system_media.png": "8964",
	"./video.png": "9e44",
	"./xlsx.png": "31c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b17c";